import 'gridstrap/svg-symbols/close.svg?sprite';
import './modal.scss';

import { components } from 'gridstrap/lib/gs-components';
import { GSModal } from './modal';
import { GSModalService } from './modal-service';

components.register({
	selector: '.gs-Modal',
	controller: GSModal
});

export const modal = new GSModalService();
